<template>
	<div :class="$style.container" ref="containerRef" :style="containerStyle">
		<div :class="$style.control">
			<!-- 汇聚全球船舶公司255家，船舶1823艘 -->
			<!-- <div v-if="keyword" class="flex">
				<button class=" transition-colors hover:text-primary" @click="onBack">
					<i class="el-icon-back" />
				</button>
				<div class="text-dark text-base flex-1 ml-1">
					返回查看全部船舶，共<span class="text-primary">{{ total?.cruise }}</span>艘
				</div>
			</div> -->
			<!-- <div v-else class="text-dark text-base">汇聚全球船舶公司<span class="text-primary">{{
				total?.company
			}}</span>家，船舶<span class="text-primary">{{ total?.cruise }}</span>艘</div> -->
			<div  class="text-dark text-base">当前游轮搜索结果</div>
			<button class="ml-auto transform transition-transform" @click="handleToggleExpand">
				<i class="el-icon-arrow-down transform" :class="[expaned ? 'rotate-180' : '']" />
			</button>
		</div>
		<collapse-transition>
			<div v-if="expaned" :class="$style.cruiseList">
				<el-scrollbar :wrap-class="$style.scroller">
					<div ref="listRef">
						<index-cruise-item class="px-4" v-for="cruise in cruises" :key="cruise.id" :cruise="cruise"
							role="list-item" />
						<div v-if="loading" class="py-4 text-center">正在加载...</div>
						<div v-if="finished && cruises.length > 0" class="py-4 text-center">没有更多了</div>
						<div v-if="!loading && !cruises.length" class="py-4">
							<el-empty :image-size="212" image="~@/assets/img/company/search/empty.png"
								description="很抱歉，您搜索信息，暂未匹配到" />
						</div>
					</div>

					<!-- <infinite-loading  :identifier="identifier" @infinite="onLoad">
									<div class="py-4" slot="spinner">正在加载...</div>
									<div class="py-4" slot="no-more">没有更多了</div>
									<div class="py-4" slot="no-results">
										<el-empty :image-size="212" image="~@/assets/img/company/search/empty.png"
											description="很抱歉，您搜索信息，暂未匹配到" />
									</div>
								</infinite-loading> -->
				</el-scrollbar>
			</div>
		</collapse-transition>
</div>
</template>
<script>
import {
	computed,
	defineComponent,
	reactive,
	ref,
	useRoute,
	useRouter,
	watch,
	onMounted,
	nextTick
} from "@nuxtjs/composition-api";
import { useToggle } from "@vueuse/shared";

import { REQUEST_CODES } from "~/constants/const-http";
// import { onClickOutside } from "@vueuse/core";

import IndexCruiseItem from "./index-cruise-item.vue";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

import { getAisCruiseList } from "~/services/company";

import useInfiniteLoading from '~/composables/useInfiniteLoading'

import useLayout from "~/composables/useLayout";


export default defineComponent({
	name: "IndexCruiseList",
	components: {
		IndexCruiseItem,
		CollapseTransition
	},
	emits: ["load-next", 'reset'],
	props: {
		searchData: {
			type: Object,
			default: () => ({
				class_id: [],
				tonnage: [],
				navistatus: [],
				renovation_time_start: "",
				renovation_time_end: "",
				first_flight_time_start: "",
				first_flight_time_end: "",
				company_id: [],
				keyword: ""
			})
		}
	},
	setup(props, { emit }) {
		const [expaned, toggleExpaned] = useToggle(true);
		const containerRef = ref();
		const cruises = ref([]);
		const route = useRoute();
		const router = useRouter();
		const keyword = computed(() => route.value.query.keyword);
		
		const { root: listRef, onLoad, finished, loading, updateLoading, updateFinished } = useInfiniteLoading()
		
		async function fetchCruiseList() {
			const { code, data, msg } = await getAisCruiseList({
				page_index: pagination.page_index,
				page_size: pagination.page_size,
				// keyword: keyword.value,
				...props.searchData
			});

			if (code !== REQUEST_CODES.ERROR_OK) {
				throw new Error(msg);
			}
			const { list, cruise_company_num, cruise_num, ...pages } = data;
			Object.assign(total, {
				cruise: cruise_num,
				company: cruise_company_num
			});
			if (list.length) {
				cruises.value = cruises.value.concat(list);
				Object.assign(pagination, {
					page_index: pages.page_index,
					page_size: pages.page_size,
					total_page: pages.total_page
				});

			}
			return data;
		}
		const pagination = reactive({
			page_index: 0,
			page_size: 10,
			total_page: 1
		});
		const total = reactive({
			cruise: 0,
			company: 0
		});
		// const identifier = ref(0);
		// async function onLoadCruiseList($state) {
		// 	try {
		// 		if (cruises.value.length) {
		// 			pagination.page_index += 1;
		// 		}
		// 		const { list, cruise_company_num, cruise_num, ...pages } = await fetchCruiseList();
		// 		if (cruises.value.length) {
		// 			$state.loaded();
		// 		}
		// 		if (pages.page_index >= pages.total_page) {
		// 			$state.complete();
		// 		}
		// 	} catch (error) {
		// 		console.error(error);
		// 		$state.error();
		// 	}
		// }

		function resetPage() {
			cruises.value = [];
			pagination.page_index = 1;
			pagination.total_page = 1;
			updateFinished(false);
			// identifier.value += 1;
		}
		watch(
			() => props.searchData,
			() => {
				resetPage();
				handlerLoad();
			},
			{
				deep: true
			}
		);

		function onBack() {
			emit('reset')
		}
		onMounted(async () => {
			handlerLoad();
		})



		async function handlerLoad() {
			updateLoading(true);
			const { page_index, total_page } = await fetchCruiseList();
			nextTick(() => {
				updateLoading(false);
				if (page_index >= total_page) {
					updateFinished(true);
				}
			})
		}
		onLoad(() => {
			pagination.page_index += 1;
			console.log('onload')
			handlerLoad();
		})

		const handleToggleExpand = () => {
			toggleExpaned();
		}


		const {headerSize} = useLayout();
		const containerStyle = computed(() => ({
			'max-height': `calc(100vh - ${ headerSize.height + 154 }px)`
		}))

		return {
			containerRef,
			containerStyle,

			listRef,
			expaned,
			toggleExpaned,
			total,

			finished,
			loading,
			cruises,
			// identifier,
			// onLoad: onLoadCruiseList,

			keyword,
			onBack,

			handleToggleExpand
		};
	}
});
</script>
<style lang="scss" module>
.container {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
.control {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.control::before {
  content: "";
  border-top-width: 1px;
  height: 0px;
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 0px;
}
.cruiseList {
  overflow: hidden;
  position: relative;
}
.scroller {
  max-height: calc(100vh - 198px);
}
</style>